import featureConfigApi from "../api/feature-config-api";

// Normalize whatever list shape the backend returns into an array of { key, value }.
// Tolerates: bare array, { data: [...] }, { list: [...] }, { configs: [...] },
// or a plain key/value map object.
const normalizeList = (resp) => {
    if (!resp) {
        return [];
    }
    const raw = resp.data || resp.list || resp.configs || resp.featureConfig || resp;
    if (Array.isArray(raw)) {
        return raw.map((item) => ({ key: item.key, value: item.value }));
    }
    if (typeof raw === "object") {
        return Object.keys(raw).map((key) => ({ key, value: raw[key] }));
    }
    return [];
};

const list = async () => {
    try {
        const resp = await featureConfigApi.list();
        return normalizeList(resp);
    } catch (err) {
        console.error(err);
        throw err;
    }
};

// payload: { configs: [{ key, value }, ...] }
const update = async (configs) => {
    try {
        const resp = await featureConfigApi.update({ configs });
        // Some endpoints return the SUCCESS envelope, others return the updated list.
        if (resp && resp.status && resp.status !== "SUCCESS") {
            throw resp.responseMsgTh || resp.message;
        }
        return resp;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

const featureConfigService = {
    list,
    update,
    normalizeList,
};

export default featureConfigService;
